import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button, Space } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import DateComponent from '../../components/date/Date';
import Select from '../../components/selects/Select';
import api from '../../services/api';
import { displayMessage } from '../../helpers/messages';
import { showErrorMessage } from '../../services/messages';
import dayjs from 'dayjs';

const DashboardFilters = ({ onFilter, onClear, initialValues }) => {
  const [form] = Form.useForm();
  const [clients, setClients] = useState([]);
  const [loadingClients, setLoadingClients] = useState(false);

  useEffect(() => {
    loadClients();
    if (initialValues) {
      form.setFieldsValue({
        startDate: initialValues.startDate,
        endDate: initialValues.endDate,
        clientIds: initialValues.clientIds
      });
    }
  }, []);

  const loadClients = async () => {
    setLoadingClients(true);
    try {
      const response = await api.client.list({ is_active: true });
      setClients(response.data);
    } catch (error) {
      showErrorMessage(error?.response?.data?.error || 'Erro ao carregar clientes');
    } finally {
      setLoadingClients(false);
    }
  };

  const handleSubmit = (values) => {
    onFilter({
      startDate: values.startDate,
      endDate: values.endDate,
      clientIds: values.clientIds || []
    });
  };

  const handleClear = () => {
    form.resetFields();
    // Resetar para última semana
    form.setFieldsValue({
      startDate: dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
      clientIds: []
    });
    onClear();
  };

  const clientOptions = clients.map(client => ({
    value: client.id,
    label: `${client.company_name}${client.nickname ? ` (${client.nickname})` : ''}`
  }));

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="vertical"
      initialValues={initialValues}
    >
      <Row gutter={16}>
        <Col xs={24} sm={8} md={6}>
          <Form.Item
            label="Data Início"
            name="startDate"
            rules={[{ required: true, message: 'Data início é obrigatória' }]}
          >
            <DateComponent placeholder="Selecione a data" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={8} md={6}>
          <Form.Item
            label="Data Fim"
            name="endDate"
            rules={[{ required: true, message: 'Data fim é obrigatória' }]}
          >
            <DateComponent placeholder="Selecione a data" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={8} md={8}>
          <Form.Item
            label="Clientes (opcional)"
            name="clientIds"
          >
            <Select
              mode="multiple"
              placeholder="Selecione um ou mais clientes"
              options={clientOptions}
              loading={loadingClients}
              showSearch
              allowClear
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>
        </Col>

        <Col xs={24} sm={24} md={4} style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
          <Form.Item style={{ marginBottom: 0, width: '100%' }}>
            <Space style={{ width: '100%' }}>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                htmlType="submit"
              >
                Filtrar
              </Button>
              <Button
                icon={<ClearOutlined />}
                onClick={handleClear}
              >
                Limpar
              </Button>
            </Space>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default DashboardFilters;

